import React, { useState } from "react";
import { setFormValues } from "../../../app/slices/applicationsSlice";
import Checkbox from "@mui/material/Checkbox";
import { useSelector, useDispatch } from "react-redux";

const FinalizationFragment = ({ allFormErrors }) => {
  const { formValues } = useSelector(({ applications }) => applications);
  const dispatch = useDispatch();

  //builders
  return (
    <div className="app-padding">
      <h2 className="mb-10">Finalization</h2>
      <div className="mt-20 mb-30">
        Your application will be submitted to evaluators at the Bank of Tanzania
        for review. You will be notified on your application's progress
        periodically via contact person's email address or phone provided on
        prior steps.
      </div>
      <div className="flex-row">
        <div className="mr-10">
          <Checkbox
            name="hasAgreed"
            checked={formValues?.hasAgreed}
            onChange={(e) => {
              dispatch(
                setFormValues({
                  ...formValues,
                  hasAgreed: !(formValues?.hasAgreed || false),
                })
              );
            }}
          />
        </div>
        <div className="#888">
          I declare that I have read & understood all information from prior
          steps and have provided correct information for this application.
        </div>
      </div>
      {allFormErrors && (
        <div className="mb-20 mt-30">
          <h4 className="mb-10">
            Please resolve the following{" "}
            <span className="text-red">errors</span> before proceeding
          </h4>
          {allFormErrors.map((error) => (
            <div className="flex-row mb-10 align-items-center">
              <div className="list-bullet mr-10"></div>
              <div className="text-red">{error}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FinalizationFragment;
